import * as actionType from "../constants";
import * as commonData from "../Common";

export const boardDeactivate = (inputs) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${api}board-update`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.DEACTIVATE_BOARD,
        payload: {
          key: inputs.attribute_set_key,
          data: rdata.data,
          message: rdata.message,
          status: rdata.status,
          code: rdata.code,
        },
      });
      return rdata;
    } else {
      return rdata;
    }
  } catch (error) {
    console.log(error);
  }
};
